export default "__VITE_ASSET__DZ1Uhbxf__"